<template>
  <v-container
    fluid
    :class="[
      'asc-page-error--container',
      errorType === 500 ? 'no-nav' : 'with-nav',
    ]"
  >
    <asc-page-error-template :error-type="errorType" />
  </v-container>
</template>

<script>
import { AscPageErrorTemplate } from '@/components/templates'

export default {
  name: 'AscPageErrorContainer',

  components: {
    AscPageErrorTemplate,
  },

  props: {
    errorType: {
      type: [Number, String],
      default: 500,
    },
  },
}
</script>

<style lang="scss">
.asc-page-error {
  &--container {
    &.no-nav {
      height: 100%;
    }
    &.with-nav {
      height: calc(100vh - 84px);
      padding: 16px;
    }
  }
}
</style>
